import { useEffect, useState } from "react";
import { Alert, Col, Container, ListGroup, Row } from "react-bootstrap";
import { Eye } from "react-feather";
import { Helmet } from "react-helmet-async";

import { LoadingBox } from "../../components/Loader";
import ShipmentRackItems from "./components/shipmentRacks/ShipmentRackItems";
import ShipmentRacks from "./components/shipmentRacks/ShipmentRacks";

import shipmentService from "../../services/shipmentService";
import utilsService from "../../services/utils.service";

const ShipmentRacksPage = () => {
  const [initializing, setInitializing] = useState(true);

  const [listingAccounts, setListingAccounts] = useState();
  const [shipmentCategories, setShipmentCategories] = useState();

  const [selectedListingAccount, setSelectedListingAccount] = useState();
  const [selectedShipmentCategory, setSelectedShipmentCategory] = useState();
  const [selectedShipmentRack, setSelectedShipmentRack] = useState();

  const [shipmentRacks, setShipmentRacks] = useState();

  useEffect(() => {
    const controller = new AbortController();

    const initialize = async () => {
      try {
        const listingAccountsResult = await utilsService.getListingAccounts(
          {
            amazonOnly: true,
          },
          controller.signal
        );

        if (listingAccountsResult.success) {
          setListingAccounts(listingAccountsResult.listingAccounts);
        }

        const shipmentCategoriesResult =
          await shipmentService.getShipmentCategories(controller.signal);

        if (shipmentCategoriesResult.success) {
          setShipmentCategories(shipmentCategoriesResult.shipmentCategories);
        }
      } finally {
        if (!controller.signal.aborted) {
          setInitializing(false);
        }
      }
    };

    initialize();

    return () => controller.abort();
  }, []);

  return (
    <>
      <Helmet title="Shipment Racks" />
      <Container fluid className="p-0">
        <h1>Shipment Racks</h1>
        {initializing ? (
          <LoadingBox />
        ) : (
          listingAccounts && (
            <>
              <Row className="mb-3">
                <Col xxl={8}>
                  <ListGroup horizontal>
                    {listingAccounts.map((account, index) => {
                      return (
                        <ListGroup.Item
                          tag="a"
                          key={index}
                          className="text-center"
                          onClick={() => setSelectedListingAccount(account)}
                          action
                          active={selectedListingAccount === account}
                          // disabled={submitting}
                        >
                          {account.listingAccount}
                        </ListGroup.Item>
                      );
                    })}
                  </ListGroup>
                </Col>
              </Row>
              {selectedListingAccount ? (
                <Row>
                  <Col xs={6}>
                    <ShipmentRacks
                      selectedListingAccount={selectedListingAccount}
                      selectedShipmentRack={selectedShipmentRack}
                      selectedShipmentCategory={selectedShipmentCategory}
                      setSelectedShipmentCategory={setSelectedShipmentCategory}
                      setSelectedShipmentRack={setSelectedShipmentRack}
                      shipmentCategories={shipmentCategories}
                      shipmentRacks={shipmentRacks}
                      setShipmentRacks={setShipmentRacks}
                    />
                  </Col>
                  {selectedShipmentRack &&
                    selectedShipmentRack.shipmentRackItems && (
                      <Col xs={6}>
                        <ShipmentRackItems
                          selectedAccount={selectedListingAccount}
                          selectedShipmentRack={selectedShipmentRack}
                          setSelectedShipmentRack={setSelectedShipmentRack}
                          shipmentRacks={shipmentRacks}
                          setShipmentRacks={setShipmentRacks}
                        />
                      </Col>
                    )}
                </Row>
              ) : (
                <Row>
                  <Col
                    xxl={8}
                    className="sticky-top"
                    xl={{ span: 8, order: "last" }}
                    style={{ top: 20 }}
                  >
                    <Alert variant="primary">
                      <div className="alert-icon">
                        <Eye
                          className="position-relative top-50 start-50 translate-middle"
                          size={20}
                        />
                      </div>
                      <div className="alert-message">
                        Select an <strong>account</strong> to view shipment
                        racks.
                      </div>
                    </Alert>
                  </Col>
                </Row>
              )}
            </>
          )
        )}
      </Container>
    </>
  );
};

export default ShipmentRacksPage;
